export const logoPathStorage = "x-logo-path"
export const siteLogoPath = "x-site-logo-path"
export const landingPage = "x-landing-page"

export const setLocalStorage = (key, value) => localStorage.setItem(key, value)
export const getLocalStorage = (key) => localStorage.getItem(key)